import { Schema } from 'effect';
import { SiteId } from './common.js';
/**
 * DTO schemas for the /ical group. See http/payment.ts for conventions.
 *
 * The feed itself (`GET /ical/:site`) is a raw `text/calendar` route with no
 * response schema; only the key-rotation POST has a JSON response.
 */
export const SiteParams = Schema.Struct({ site: SiteId });
export const FeedQuery = Schema.Struct({
    icalKey: Schema.optional(Schema.String),
    log: Schema.optional(Schema.String)
});
/**
 * The key itself is generated server-side (F-CRYPTO-01), so the body only says
 * whether to rotate or to clear. `icalKey` is retained and ignored: the
 * deployed client sends a browser-generated key, and accepting-and-discarding
 * it keeps that client working while it is replaced.
 */
export const SetKeyBody = Schema.Struct({
    icalKey: Schema.optional(Schema.String),
    clear: Schema.optional(Schema.Boolean)
});
export const SetKeyResponse = Schema.Struct({
    message: Schema.String,
    icalKey: Schema.String
});
//# sourceMappingURL=ical.js.map